import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import NavBar from '../../components/NavBar';
import { Footer } from '../../components/Footer/Footer';

import { useLocalStorage } from '../../CustomHooks/useLocalStorage';
import { setUserInfo } from '../../actions';

import { TOKEN, LOGOUT, handleSettingsClick } from '../../constants';

import { getOrSetAnonymousUserId } from '../../utils';

import { PartnerWithUs } from './PartnerWithUs';

export const Partner = () => {
  const { jwt, isSubmitted, loading, user } = useSelector(
    ({ userReducer: { jwt, user }, contactReducer: { isSubmitted, loading } }) => ({
      jwt,
      isSubmitted,
      loading,
      user,
    }),
  );

  const dispatch = useDispatch();

  const [value] = useLocalStorage(TOKEN);

  useEffect(() => {
    if (value || jwt) {
      if (!localStorage.getItem(TOKEN)) {
        return;
      }
      const user = atob(localStorage.getItem(TOKEN)?.split('.')?.[1]);
      const parsedUser = JSON.parse(user);

      if (parsedUser) {
        dispatch((dispatch) => setUserInfo(dispatch, parsedUser));
        const date = new Date(parsedUser.exp * 1000);
        const now = new Date();
        if (date < now) {
          handleSettingsClick[LOGOUT]?.(dispatch, parsedUser);
          return;
        }
      } else {
        const anonymousUserId = getOrSetAnonymousUserId();

        dispatch((dispatch) => setUserInfo(dispatch, { anonymousUserId }));
      }
    } else {
      const anonymousUserId = getOrSetAnonymousUserId();

      dispatch((dispatch) => setUserInfo(dispatch, { anonymousUserId }));
    }
  }, [value, jwt]);

  return (
    <div>
      <NavBar currentPath="Partner" userId={user?.id || user?.anonymousUserId} />
      <PartnerWithUs user={user} isSubmitted={isSubmitted} loading={loading} token={value} />
      <Footer currentPath="/partner" />
    </div>
  );
};
